export default {
	methods: {
		groupProducts(productList) {
			const productGroups = {
				onlyItem: {},
				onlyArticle: {},
			};

			// order to show products and product groups
			const productDisplayOrder = new Set();

			// final products and product groups array
			const productsArray = [];

			// group product keys that need to be grouped
			for (const product of productList) {
				const {itemMaterialType, articleNumber, productConfigurator} = product;

				// only care about products with configurator options
				if (productConfigurator?.length && (articleNumber || itemMaterialType)) {
					// build groups for products with both props
					if (itemMaterialType && articleNumber) {
						if (!productGroups[itemMaterialType]) productGroups[itemMaterialType] = {};
						if (!productGroups[itemMaterialType][articleNumber])
							productGroups[itemMaterialType][articleNumber] = new Set();
						productGroups[itemMaterialType][articleNumber].add(product);
						productDisplayOrder.add(productGroups[itemMaterialType][articleNumber]);
					}

					// build groups with only item prop
					else if (itemMaterialType && !articleNumber) {
						if (!productGroups.onlyItem[itemMaterialType])
							productGroups.onlyItem[itemMaterialType] = new Set();
						productGroups.onlyItem[itemMaterialType].add(product);
						productDisplayOrder.add(productGroups.onlyItem[itemMaterialType]);
					}

					// build groups with only article prop
					else if (articleNumber && !itemMaterialType) {
						if (!productGroups.onlyArticle[articleNumber])
							productGroups.onlyArticle[articleNumber] = new Set();
						productGroups.onlyArticle[articleNumber].add(product);
						productDisplayOrder.add(productGroups.onlyArticle[articleNumber]);
					}
				} else {
					const set = new Set([product]);
					productDisplayOrder.add(set);
				}
			}

			// remove product groups we don't need and set final products array
			for (const set of productDisplayOrder.values()) {
				// create group of array of objects
				if (set.size > 1) productsArray.push([...set.values()]);
				// extract product object
				else productsArray.push(...set.values());
			}
			return productsArray;
		},
	},
};
